export const LANDING = 'Welcome 🖖';
export const CART = 'Your Cart 🛒';
export const WISHLIST = 'Your Wishlist ❤️';
export const NOT_FOUND = 'Page Not Found 🤦🏻‍';
